import React from "react";

import { useMediaQuery } from "@material-ui/core";

import Navbar from "./Navbar";
import MobileNavbar from "../../pages/RodaHomepage/components/MobileNavbar";

type NavigationProps = {
  setSelectedRequest?: React.Dispatch<React.SetStateAction<number>>;
};

export default function Navigation({ setSelectedRequest }: NavigationProps) {
  const isHamburgerMenu = useMediaQuery("(min-width: 768px)");

  return (
    <>
      {isHamburgerMenu ? (
        <Navbar setSelectedRequest={setSelectedRequest} />
      ) : (
        <MobileNavbar setSelectedRequest={setSelectedRequest} />
      )}
    </>
  );
}
